/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-07-04",
    versionChannel: "nightly",
    buildDate: "2023-07-04T00:20:28.931Z",
    commitHash: "c943866745281bad7f75fcc859ab7f2734385951",
};
